module.exports = __webpack_public_path__ + "img/hero-img.f315fab5.png";